import apiUtils from '../apiUtils';
import HTTPClient from '../HTTPClient';

import metadataAdapter from './metadataAdapter';

const getFormMetadata = (formId, payload = {}) => {
    const searchParams = new URLSearchParams();
    if (payload && payload.deliveryCountry) {
        searchParams.append('country', payload.deliveryCountry);
    }
    return `${apiUtils.getBaseUri()}/forms/${formId}?${searchParams.toString()}`;
};

const doStepValidation = async (submitUri, dto) => {
    const uri = `${apiUtils.getBaseUri()}${submitUri}`;
    return await HTTPClient().postJson(uri, dto);
};

const loadMetadata = async uri => {
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Failed loading metadata ${uri} (${response.status})`);
    }

    const metadata = await response.json();

    return metadataAdapter(metadata);
};

const doSubmit = async (submitUri = '', dto = {}, rawMethod = 'post') => {
    const uri = `${apiUtils.getBaseUri()}${submitUri}`;
    const method = rawMethod.toLowerCase();
    const methodsMapper = {
        post: 'postJson',
        patch: 'patchJson',
        put: 'putJson',
    };

    const httpFunction = methodsMapper[method] || method;
    const response = await HTTPClient()[httpFunction](uri, dto);
    let responseData = {};

    try {
        responseData = await response.json();
    } catch (e) {
        /* Nothing */
    }

    if (!response.ok) {
        throw {
            json: responseData,
            status: response.status,
            message: response.message,
        };
    }

    return responseData;
};

export default {
    getFormMetadata,
    doStepValidation,
    loadMetadata,
    doSubmit,
};
